/*eslint-disable */
define(function (require) {
	'use strict';

	var Backbone = require('backbone');


	var DayModel = Backbone.Model.extend({

	});

	return DayModel;
});